import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AppUpdateService } from './core/services/app-update.service';
import { PwaInstallService } from './core/services/pwa-install.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <router-outlet></router-outlet>
    @if (appUpdate.updateAvailable()) {
      <div class="update-banner">
        <span>A new version of this app is available.</span>
        <button type="button" (click)="appUpdate.reloadForUpdate()">Reload now</button>
      </div>
    }
  `,
  styles: [
    `
      .update-banner {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 0.75rem 1rem;
        background: var(--ion-color-warning, #ffc409);
        color: var(--ion-color-warning-contrast, #000);
      }

      .update-banner button {
        border: none;
        border-radius: 4px;
        padding: 0.4rem 0.9rem;
        font-weight: 600;
        cursor: pointer;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  /**
   * Injected eagerly at bootstrap, not lazily inside EnrollComponent — the
   * browser fires `beforeinstallprompt` once, at any point after load, and
   * doesn't replay it. A listener attached only when the user later
   * navigates to /enroll would miss an event that already fired.
   */
  private readonly pwaInstall = inject(PwaInstallService);

  protected readonly appUpdate = inject(AppUpdateService);
}